<template>
  <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel" v-for="(message, index) in messages" :key="index">
      <div class="panel-heading row" role="tab" :id="'heading' + message.id">
        <a
          class="collapsed qa-question"
          role="button"
          data-toggle="collapse"
          data-parent="#accordion"
          aria-expanded="false"
          :href="'#collapse' + message.id"
          :aria-controls="'collapse' + message.id"
          :style="message.thread.length <= 1 ? 'cursor: inherit;' : ''"
        >
          <div class="row">
            <div class="col-md-2">
              <h5 class="qa-label">Question:</h5>
            </div>
            <div class="col-md-8 qa-content">
              <div v-html="message.body"></div>
              <p class="qa-author" v-if="message.user_profile.company_name === 'Admin'">- {{ toTitleCase(message.domain) + ' Support' }}</p>
              <p class="qa-author" v-else>- {{ toTitleCase(message.user_profile.company_name) }}</p>
            </div>
            <div class="col-md-2">
              <p class="qa-date">{{ formatDate(message.created_at) }}</p>
              <p class="qa-count" v-show="message.thread.length > 1">View {{ message.thread.length - 1 }}
                <span v-if="message.thread.length - 1 === 1">&nbsp;more answer</span>
                <span v-else>&nbsp;more answers</span>
              </p>
            </div>
          </div>
          <div class="row" v-if="message.thread.length">
            <div class="col-md-2">
              <h5 class="qa-label">Answer:</h5>
            </div>
            <div class="col-md-8 qa-content">
              <div v-html="message.thread[0].body"></div>
              <p class="qa-author" v-if="message.thread[0].user_profile.company_name === 'Admin'">- {{ toTitleCase(message.thread[0].domain) + ' Support' }}</p>
              <p class="qa-author" v-else>- {{ toTitleCase(message.thread[0].user_profile.company_name) }}</p>
            </div>
          </div>
        </a>
      </div>
      <div class="panel-collapse collapse" role="tabpanel" v-if="message.thread.length > 1" :id="'collapse' + message.id" :aria-labelledby="'heading' + message.id">
        <div class="panel-body qa-answer">
          <div class="row" v-for="(reply, index) in message.thread.slice(1, message.thread.length)" :key="index">
            <div class="col-md-2">
              <h5 class="qa-label">Answer:</h5>
            </div>
            <div class="col-md-8 qa-content">
              <div v-html="reply.body"></div>
              <p class="qa-author" v-if="reply.user_profile.company_name === 'Admin'">- {{ toTitleCase(reply.domain) + ' Support' }}</p>
              <p class="qa-author" v-else>- {{ toTitleCase(reply.user_profile.company_name) }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <button class="btn btn-default" v-if="replyCommentId != message.id && userLoggedIn" @click.prevent="replyCommentId = message.id">
          <i class="fa fa-comment-o" aria-hidden="true"></i> Add reply</button>
        <form class="col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2" v-show="replyCommentId === message.id">
          <div class="form-group text-left">
            <label>Reply:</label>
            <textarea class="form-control" name="comment" rows="4" placeholder="Enter text here..." v-model="comment.payload.body" required></textarea>
          </div>
          <div class="form-group text-left group-btn">
            <button class="btn btn-black" type="submit" value="Submit" @click.prevent="replyMessage(message)" data-trigger="focus">Submit</button>
            <button class="btn btn-link" @click.prevent="replyCommentId = null">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import dateMixin from '../mixins/date';

  export default {
    name: 'product-messages',
    props: {
      messages: Array
    },
    data() {
      return {
        replyCommentId: null,
        comment : {
          payload : {
            body : '',
            group : 'qa',
            type: 'comment'
          },
          response : {
            type : '',
            message : ''
          }
        },
        notifications : []
      }
    },

    mixins: [
      dateMixin
    ],

    computed: {
      userLoggedIn() {
        return this.$root.isLoggedIn;
      },
    },

    methods: {
      async replyMessage(message) {

        if (!this.comment.payload.body) {

          this.comment.response.type = 'error';

          this.$root.$refs.notifications.add({
            delay: false,
            type: "warning",
            icon: "exclamation-triangle",
            title: "Unable to submit reply",
            message: `Reply message is required.`
          })

          this.dismissNotification();

          return;

        }

        const postReplyUrl = `/api/proxify/domains/${message.domain}/messages/${message.id}/response`;

        try {

          await axios.post(postReplyUrl, this.comment.payload);

          this.$root.$refs.notifications.add({
            delay: false,
            type: "success",
            icon: "check",
            title: "Reply submitted",
            message: `Your reply was uploaded successfully, but must be
            approved before it is visible.`
          });

          this.dismissNotification();

          this.comment.payload.body = '';

        } catch (error) {

            console.error({ error })

            this.$root.$refs.notifications.add({
              delay: false,
              type: "error",
              icon: "exclamation-triangle",
              title: "Unable to submit reply",
              message: `Make sure all required fields are complete.`
            });

            this.dismissNotification();

        } finally {

          this.replyCommentId = null;

        }
      },

      dismissNotification() {

        setTimeout(() => {
          this.$root.$refs.notifications.notifications = [];
        }, 1000);

      },

      toTitleCase(text) {

        if(text === null && this.$root.product) {
          text = this.$root.product.domain + ' Support';
        }
        else if (text === null && this.$root.article) {
          text = this.$root.article.domain + ' Support';
        }

        return text.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');

      }
    }
  }
</script>